export default {
	verbose_name: {
		en: 'campaign',
		ge: 'კამპანია',
		de: 'Kampagne',
		ru: 'Кампания',
		cn: '活动'
	},
	step02_welcome_message: {
		en: 'Please, select your campaign type',
		ge: 'გთხოვთ, აირჩიოთ თქვენი კამპანიის ტიპი',
		de: 'Bitte wählen Sie Ihren Kampagnentyp',
		ru: 'Пожалуйста, выберите тип кампании',
		cn: '请选择您的活动类型'
	},
	step02_goal: {
		en: 'goal',
		ge: 'მიზანი',
		de: 'Ziel',
		ru: 'цель',
		cn: '目标'
	},
	model_and_goal_error: {
		en: 'Please check model and goal fields',
		ge: 'გთხოვთ შეამოწმოთ მოდელის და მიზნის ველები',
		de: 'Bitte überprüfen Sie die Felder Modell und Ziel',
		ru: 'Пожалуйста, проверьте поля выбора модели и ввода цели',
		cn: '请检查模式和目标字段'
	},
	payment_model_label: {
		en: 'Campaign type',
		ge: 'კამპანიის ტიპი',
		de: 'Kampagnentyp',
		ru: 'Тип кампании',
		cn: '活动类型是'
	},
	model_choose_string01: {
		en: 'Campaign type is',
		ge: 'კამპანიის ტიპი არის',
		de: 'Der Kampagnentyp ist',
		ru: 'Тип кампании',
		cn: '活动类型是'
	},
	model_choose_string02__ad_plays: {
		en: 'Goal is to reach',
		ge: 'მიზანი მიღწევადია',
		de: 'Das Ziel ist zu erreichen',
		ru: 'Цель достичь',
		cn: '目标是达到'
	},
	model_choose_string02__cpm: {
		en: 'Goal is to reach',
		ge: 'მიზანი მიღწევადია',
		de: 'Das Ziel ist es, die Zielgruppe zu erreichen',
		ru: 'Цель достичь аудитории',
		cn: '目标是达到'
	},
	model_choose_string02__cpv: {
		en: 'Goal is to reach',
		ge: 'მიზანი მიღწევადია',
		de: 'Das Ziel ist zu erreichen',
		ru: 'Цель достичь',
		cn: '目标是达到'
	},
	model_choose_string03__ad_plays: {
		en: 'shows',
		ge: 'ჩვენება',
		de: 'Shows',
		ru: 'показов',
		cn: '播放'
	},
	model_choose_string03__cpm: {
		en: 'impressions',
		ge: 'შთაბეჭდილებები',
		de: 'Impressionen',
		ru: 'аудитория',
		cn: '展示'
	},
	model_choose_string03__cpv: {
		en: 'guaranteed views',
		ge: 'გარანტირებული ნახვები',
		de: 'garantierte Aufrufe',
		ru: 'гарантированных просмотров',
		cn: '保证观看'
	},
	audience_label: {
		en: 'audience',
		ge: 'აუდიტორია',
		de: 'Zielgruppe',
		ru: 'аудитория',
		cn: '受众'
	},
	audience_hint: {
		en: 'This option allows you to&nbsp;filter the broadcast points by&nbsp;interests or&nbsp;other historical audience data. For example, select screens with an&nbsp;audience interested in&nbsp;face creams.',
		ge: 'ეს პარამეტრი საშუალებას გაძლევთ&nbsp;გაფილტროთ სამაუწყებლო პუნქტები&nbsp;ინტერესების ან&nbsp;სხვა ისტორიული აუდიტორიის მონაცემების მიხედვით. მაგალითად, აირჩიეთ ეკრანები&nbsp;აუდიტორიით დაინტერესებული&nbsp;სახის კრემებით.',
		de: 'Diese Option ermöglicht es Ihnen, die Übertragungspunkte nach Interessen oder anderen historischen Zielgruppendaten zu filtern. Beispielsweise können Sie Bildschirme mit einer Zielgruppe auswählen, die an Gesichtscremes interessiert ist.',
		ru: 'Этот параметр позволяет фильтровать точки вещания по интересам или другим историческим данным об аудитории. Например, отобрать экраны с аудиторией интересущейся кремами для лица.',
		cn: '通过此选项，您可以按照兴趣或其他历史受众数据筛选播放点。例如，选择对面霜感兴趣的受众附近的屏幕。'
	},
	platform_label: {
		en: 'network',
		ge: 'ქსელი',
		de: 'Netzwerk',
		ru: 'рекламная сеть',
		cn: '网络'
	},
	all_platforms_label: {
		en: 'All networks',
		ge: 'ყველა ქსელი',
		de: 'Alle Netzwerke',
		ru: 'Все сети',
		cn: 'All networks'  // TODO: translation needed
	},
	platform_hint: {
		en: 'Select a network for the playback of the Сampaign',
		ge: 'აირჩიეთ ქსელი კამპანიის გასაშვებად',
		de: 'Wählen Sie ein Netzwerk für die Wiedergabe der Kampagne',
		ru: 'Выберите рекламную сеть для проигрывания Кампании',
		cn: '选择播放活动所使用的网络 '
	},
	selected_platforms: {
		en: 'Selected <b>{num}</b> networks',
		ge: 'არჩეული <b>{num}</b> ქსელები',
		de: 'Ausgewählte <b>{num}</b> Netzwerke',
	  ru: 'Выбрано <b>{num}</b> сетей',
	  cn: 'Selected <b>{num}</b> networks'  // TODO: translation needed
	},
	reset_platforms_selection_confirmation_text: {
		en: 'Clear selected and select all networks?',
		ge: 'გასუფთავდეს არჩეული და შეარჩიო ყველა ქსელი?',
		de: 'Auswahl löschen und alle Netzwerke auswählen?',
		ru: 'Очистить выбранные опции и выбрать все сети?',
		cn: 'Clear selected and select all networks?'  // TODO: translation needed
	},
	age_label: {
		en: 'age',
		ge: 'ასაკი',
		de: 'Alter',
		ru: 'возраст',
		cn: '年龄'
	},
	gender_label: {
		en: 'gender',
		ge: 'სქესი',
		de: 'Geschlecht',
		ru: 'пол',
		cn: '性别'
	},
	male: {
		en: 'Male',
		ge: 'მამაკაცი',
		de: 'Männlich',
		ru: 'Муж.',
		cn: '男性'
	},
	m70: {
		en: '70% M',
		ge: '70% კ',
		de: '70% M',
		ru: '70% М',
		cn: '70% 男性'
	},
	female: {
		en: 'Female',
		ge: 'ქალი',
		de: 'Weiblich',
		ru: 'Жен.',
		cn: '女性'
	},
	f70: {
		en: '70% F',
		ge: '70% ქ',
		de: '70% F',
		ru: '70% Ж',
		cn: '70% 女性'
	},
	interests: {
		en: 'interests',
		ge: 'ინტერესები',
		de: 'Interessen',
		ru: 'интересы',
		cn: '兴趣'
	},
	feedback: {
		en: 'feedback',
		ge: 'უკუკავშირი',
		de: 'Rückmeldung',
		ru: 'описание',
		cn: '反馈'
	},
	int_and_act_label: {
		en: 'Interests & Activities',
		ge: 'ინტერესები და აქტივობები',
		de: 'Interessen & Aktivitäten',
		ru: 'Интересы и активность',
		cn: '兴趣和活动'
	},
	life_stage_label: {
		en: 'life stage',
		ge: 'სიცოცხლის ეტაპი',
		de: 'Lebensphase',
		ru: 'уровень жизни',
		cn: '生命阶段'
	},
	intent_label: {
		en: 'intent',
		ge: 'მიზანი',
		de: 'Absicht',
		ru: 'вовлечение',
		cn: '意向'
	},
	environment_label: {
		en: 'environment',
		ge: 'გარემო',
		de: 'Umgebung',
		ru: 'окружение',
		cn: '环境'
	},
	environment_hint: {
		en: 'This option allows you to&nbsp;filter the broadcast points by&nbsp;the environment. For example, select the screens in&nbsp;front of&nbsp;the entrance or&nbsp;in&nbsp;the payment area.',
		ge: 'ეს პარამეტრი საშუალებას გაძლევთ &nbsp;გაფილტროთ სამაუწყებლო წერტილები&nbsp;გარემოს მიხედვით. მაგალითად, აირჩიეთ ეკრანები&nbsp;შესასვლელის წინ&nbsp; ან&nbsp; ში&nbsp;გადახდის ზონაში.',
		de: 'Diese Option ermöglicht es Ihnen, die Übertragungspunkte nach der Umgebung zu filtern. Beispielsweise können Sie Bildschirme vor dem Eingang oder im Zahlungsbereich auswählen.',
		ru: 'Эта опция позволяет отфильтровать точки вещания по окружению. Например, выбрать экраны только у входа или у касс.',
		cn: '通过此选项，您可以按照环境筛选播放点。例如，选择入口处或付款处的屏幕。'
	},
	poi_label: {
		en: 'POI',
		ge: 'ლოკაცია',
		de: 'POI',
		ru: 'POI',
		cn: 'POI'  // TODO: translation needed
	},
	poi_hint: {
		en: 'This option allows you to&nbsp;filter broadcast points by&nbsp;the environment. For example, select screens within 100 meters of a bank.',
		ge: 'ეს პარამეტრი საშუალებას გაძლევთ&nbsp;გაფილტროთ სამაუწყებლო წერტილები&nbsp;გარემოს მიხედვით. მაგალითად, აირჩიეთ ეკრანები ბანკიდან 100 მეტრში.',
		de: 'Diese Option ermöglicht es Ihnen, Übertragungspunkte nach der Umgebung zu filtern. Beispielsweise können Sie Bildschirme innerhalb von 100 Metern um eine Bank auswählen.',
		ru: 'Эта опция позволяет отфильтровать точки вещания по окружению. Например, выбрать экраны в радиусе 100 метров от банка',
		cn: 'This option allows you to&nbsp;filter broadcast points by&nbsp;the environment. For example, select screens within 100 meters of a bank.'  // TODO: translation needed
	},
	select_pois: {
		en: 'Select POIs',
		ge: 'აირჩიეთ ლოკაცია',
		de: 'POIs auswählen',
		ru: 'Выберите POI',
		cn: 'Select POIs'  // TODO: translation needed
	},
	resolution_label: {
		en: 'resolution',
		ge: 'რეზოლუცია',
		de: 'Auflösung',
		ru: 'разрешение',
		cn: '分辨率'
	},
	orientation_label: {
		en: 'orientation',
		ge: 'ორიენტაცია',
		de: 'Ausrichtung',
		ru: 'ориентация',
		cn: '方向'
	},
	type_label: {
		en: 'type',
		ge: 'ტიპი',
		de: 'Typ',
		ru: 'тип',
		cn: '类型'
	},
	week_days_label: {
		en: 'week days',
		ge: 'კვირის დღეები',
		de: 'Wochentage',
		ru: 'дни недели',
		cn: '周几'
	},
	week_rule: {
		en: 'week rule',
		ge: 'კვირის წესი',
		de: 'Wochenregel',
		ru: 'правило на неделю',
		cn: '周规则'
	},
	payment_model: {
		en: 'payment model',
		ge: 'გადახდის მოდელი',
		de: 'Zahlungsmodell',
		ru: 'модель оплаты',
		cn: '付款方式'
	},
	mon: {
		en: 'mon',
		ge: 'ორშ',
		de: 'Mo',
		ru: 'пн',
		cn: '周一'
	},
	tue: {
		en: 'tue',
		ge: 'სამშ',
		de: 'Di',
		ru: 'вт',
		cn: '周二'
	},
	wed: {
		en: 'wed',
		ge: 'ოთხშ',
		de: 'Mi',
		ru: 'ср',
		cn: '周三'
	},
	thu: {
		en: 'thu',
		ge: 'ხუთ',
		de: 'Do',
		ru: 'чт',
		cn: '周四'
	},
	fri: {
		en: 'fri',
		ge: 'პარ',
		de: 'Fr',
		ru: 'пт',
		cn: '周五'
	},
	sat: {
		en: 'sat',
		ge: 'შაბ',
		de: 'Sa',
		ru: 'сб',
		cn: '周六'
	},
	sun: {
		en: 'sun',
		ge: 'კვ',
		de: 'So',
		ru: 'вс',
		cn: '周日'
	},
	radius: {
		en: 'radius',
		ge: 'რადიუსი',
		de: 'Radius',
		ru: 'радиус',
		cn: '半径'
	},
	distance: {
		en: 'distance',
		ge: 'დისტანცია',
		de: 'Entfernung',
		ru: 'дистанция',
		cn: /* TODO: to be translated */ 'distance',
	},
	address: {
		en: 'address',
		ge: 'მისამართი',
		de: 'Adresse',
		ru: 'адрес',
		cn: '地址'
	},
	address_placeholder: {
		en: 'Enter address...',
		ge: 'შეიყვანეთ მისამართი...',
		de: 'Adresse eingeben...',
		ru: 'Введите адрес...',
		cn: '输入地址...'
	},
	radius_units_km: {
		en: 'km',
		ge: 'კმ',
		de: 'km',
		ru: 'км',
		cn: '千米'
	},
	radius_units_m: {
		en: 'm',
		ge: 'მ',
		de: 'm',
		ru: 'м',
		cn: /* TODO: to be translated */ 'm',
	},
	broadcasting_points: {
		en: 'broadcasting points',
		ge: 'მაუწყებლობის წერტილები',
		de: 'Übertragungspunkte',
		ru: 'точки вещания',
		cn: '播放点'
	},
	budget_n_schedule_title: {
		en: 'set budget and schedule',
		ge: 'დაადგინეთ ბიუჯეტი და გრაფიკი',
		de: 'Budget und Zeitplan festlegen',
		ru: 'бюджет и расписание',
		cn: '设定预算和时间表'
	},
	time_period: {
		en: 'time period',
		ge: 'დროის პერიოდი',
		de: 'Zeitraum',
		ru: 'период времени',
		cn: '时间段'
	},
	time_range: {
		en: 'time range',
		ge: 'დროის დიაპაზონი',
		de: 'Zeitraum',
		ru: 'временной интервал'
	},
	age_range: {
		en: 'age range',
		ge: 'ასაკის დიაპაზონი',
		de: 'Altersbereich',
		ru: 'возрастной интервал'
	},
	message_duration: {
		en: 'message duration',
		ge: 'გზავნილის ხანგრძლივობა',
		de: 'Nachrichtendauer',
		ru: 'Длительность',
		cn: '消息时长'
	},
	frequency_limit: {
		en: 'frequency limit',
		ge: 'სიხშირის ლიმიტი',
		de: 'Frequenzlimit',
		ru: 'частота показов',
		cn: '频率限制'
	},
	per_hour: {
		en: 'per&nbsp;hour',
		ge: 'ერთ&nbsp; საათში',
		de: 'pro&nbsp;Stunde',
		ru: 'за&nbsp;час',
		cn: '每小时'
	},
	per_device: {
		en: 'per&nbsp;device',
		ge: 'თითო&nbsp; მოწყობილობაში',
		de: 'pro&nbsp;Gerät',
		ru: 'на&nbsp;одном устройстве',
		cn: '每台设备'
	},
	per_hour_per_device: {
		en: 'per&nbsp;hour per&nbsp;device',
		ge: 'ერთ&nbsp;საათში ერთ&nbsp; მოწყობილობაზე',
		de: 'pro&nbsp;Stunde pro&nbsp;Gerät',
		ru: 'за&nbsp;час на&nbsp;одном устройстве',
		cn: '每台设备每小时'
	},
	ad_flight: {
		en: 'ad flight',
		ge: 'რეკლამის გაშვება',
		de: 'Anzeigenschaltung',
		ru: 'Протяженность',
		cn: '广告投放'
	},
	ad_flight_days: {
		en: 'Days',
		ge: 'დღეები',
		de: 'Tage',
		ru: 'Дней',
		cn: /* TODO: to be translated */ 'Days',
	},
	for_hour: {
		en: 'In {value} hour',
		ge: '{value} საათი',
		de: 'In {value} Stunde',
		ru: 'За {value} час',
		cn: /* TODO: to be translated */ 'In {value} hour',
	},
	for_minutes: {
		en: 'In {value} minutes',
		ge: '{value} წუთები',
		de: 'In {value} Minuten',
		ru: 'За {value} минут',
		cn: /* TODO: to be translated */ 'In {value} minutes',
	},
	ad_flight_hint: {
		en: 'Campaign duration, a month by default',
		ge: 'კამპანიის ხანგრძლივობა, ნაგულისხმევად ერთი თვე',
		de: 'Kampagnendauer, standardmäßig ein Monat',
		ru: 'Длительность кампании, по умолчанию месяц',
		cn: '活动时长'
	},
	target_type: {
		en: 'target type',
		ge: 'სამიზნე ტიპი',
		de: 'Zieltyp',
		ru: 'тип цели',
		cn: '目标类型'
	},
	target_type_hint: {
		en: '<div class=\'payment_model-hint\' >\n\t\t<p>In&nbsp;the first step when creating advertising it&nbsp;is&nbsp;necessary to&nbsp;choose the target. The goal should match what you want to&nbsp;achieve:</p>\n\t\t<ul>\n\t\t\t<li><b>Shows (Ad&nbsp;Plays)</b>. You want to&nbsp;achieve the number of&nbsp;ad&nbsp;plays by&nbsp;the broadcast without audience information. The best type for broadcast points without cameras or&nbsp;audience data or&nbsp;for audio marketing.</li>\n\t\t\t<li><b>Impressions (CPM)</b>. You want to&nbsp;reach your target audience. Broadcasting goes in&nbsp;cycles based on&nbsp;the audience historical data. Suitable for large screens and other massive installations or&nbsp;for audio marketing.</li>\n\t\t\t<li><b>Views (CPV)</b>. You want to&nbsp;achieve the number of&nbsp;guaranteed views of&nbsp;the target audience. Suitable for broadcast points with cameras.</li>\n\t\t</ul>\n\t</div>',
		ge: '<div class=\'payment_model-hint\' >\n\t\t<p>რეკლამის შექმნისას&nbsp;პირველ ეტაპზე&nbsp;აუცილებელია&nbsp;სამიზნის შერჩევა. მიზანი უნდა შეესაბამებოდეს იმას, რისი მიღწევაც გსურთ:</p>\n\n\t\t<ul>\n\t\t\t<li><b>შოუები (რეკლამა&nbsp;თამაშები)</b>. გსურთ&nbsp;მიაღწიოთ&nbsp;რეკლამის&nbsp;თამაშების რაოდენობას&nbsp;მაუწყებლობის მიერ აუდიტორიის ინფორმაციის გარეშე. საუკეთესო ტიპი სამაუწყებლო წერტილებისთვის კამერების ან&nbsp;აუდიტორიის მონაცემების ან&nbsp;აუდიო მარკეტინგისთვის.</li>\n\t\t\t<li><b>ჩვენებები (CPM)</b>. გსურთ&nbsp;მიაღწიოთ თქვენს სამიზნე აუდიტორიას. მაუწყებლობა მიმდინარეობს&nbsp;ციკლებში, ეფუძნება&nbsp;მაყურებლის ისტორიულ მონაცემებს. შესაფერისია დიდი ეკრანებისთვის და სხვა მასიური ინსტალაციებისთვის ან აუდიო მარკეტინგისთვის.</li>\n\n\t\t<li><b>ნახვები (CPV)</b>. გსურთ&nbsp;მიაღწიოთ&nbsp;სამიზნე აუდიტორიის&nbsp;გარანტირებული ნახვების რაოდენობას. ვარგისია კამერებით გადაცემის წერტილებისთვის.</li>\n\t\t</ul>\n\t</div>',
		de: '<div class=\'payment_model-hint\' >\n\t\t<p>Im&nbsp;ersten Schritt bei der Erstellung von Werbung muss das Ziel ausgewählt werden. Das Ziel sollte dem entsprechen, was Sie erreichen möchten:</p>\n\t\t<ul>\n\t\t\t<li><b>Shows (Ad&nbsp;Plays)</b>. Sie möchten die Anzahl der Werbeeinblendungen durch die Übertragung ohne Zuschauerinformationen erreichen. Am besten geeignet für Übertragungspunkte ohne Kameras oder Zuschauerdaten oder für Audiomarketing.</li>\n\t\t\t<li><b>Impressions (CPM)</b>. Sie möchten Ihre Zielgruppe erreichen. Die Übertragung erfolgt in Zyklen basierend auf den historischen Daten der Zielgruppe. Geeignet für große Bildschirme und andere massive Installationen oder für Audiomarketing.</li>\n\t\t\t<li><b>Views (CPV)</b>. Sie möchten die Anzahl der garantierten Aufrufe der Zielgruppe erreichen. Geeignet für Übertragungspunkte mit Kameras.</li>\n\t\t</ul>\n\t</div>',
		ru: '<div class=\'payment_model-hint\' >\n\t\t<p>При создании рекламы надо выбрать цель. Цель должна соответствовать тому, чего вы хотите добиться:</p>\n\t\t<ul>\n\t\t\t<li><b>Показы (Ad Plays)</b>. Вы хотите добиться установленного вами количества выходов кампании в эфир путём трансляции без учета аудитории. Подходит для точек вещания без камер или данных об аудитории или для аудиомаркетинга.</li>\n\t\t\t<li><b>Охват (СPM)</b>. Вы хотите добиться установленного вами охвата вашей целевой аудитории. Трансляция происходит в цикле с учётом аудитории на основе исторических данных. Подходит для больших экранов и прочих охватных инсталляций или для аудиомаркетинга.</li>\n\t\t\t<li><b>Просмотры (СPV)</b>. Вы хотите добиться установленного вами количества гарантированных просмотров целевой аудитории. Подходит для точек вещания с камерами.</li>\n\t\t</ul>\n\t</div>',
		cn: '<div class=\'payment_model-hint\' >\n\t\t<p>创建广告时，首先需要选择目标。目标要符合您的实际需求：</p>\n\t\t<ul>\n\t\t\t<li><b>播放（广告播放）</b>。您希望在没有受众信息的播放点达成一定次数的广告播放。此类型适用于没有摄像头或受众数据的播放点，以及音频营销。</li>\n\t\t\t<li><b>展示（每千次展示费用）</b>。您希望展示给特定目标受众。根据受众历史数据循环播放。此类型适用于大屏幕或其他大型装置，以及音频营销。</li>\n\t\t\t<li><b>观看（每次观看费用）</b>。您希望确保目标受众一定次数的观看。此类型适用于带有摄像头的播放点。</li>\n\t\t</ul>\n\t</div>'
	},
	target_plays: {
		en: 'target plays',
		ge: 'სამიზნე ჩვენებები',
		de: 'Ziel-Wiedergaben',
		ru: 'цель по показам',
		cn: '目标播放'
	},
	target_ots: {
		en: 'target ots',
		ge: 'სამიზნე ამოცანები',
		de: 'Ziel-OTS',
		ru: 'цель по ots',
		cn: '目标视听机会'
	},
	target_views: {
		en: 'target views',
		ge: 'სამიზნე ნახვები',
		de: 'Zielaufrufe',
		ru: 'цель по просмотрам',
		cn: '目标观看'
	},
	budget: {
		en: 'budget',
		ge: 'ბიუჯეტი',
		de: 'Budget',
		ru: 'бюджет',
		cn: '预算'
	},
	budget_hint: {
		en: '<b>Your budget</b>. Set the spending limit at which the advertising campaign will stop.',
		ge: '<b>თქვენი ბიუჯეტი</b>. დააყენეთ ხარჯვის ლიმიტი, რომელზეც შეჩერდება სარეკლამო კამპანია.',
		de: '<b>Ihr Budget</b>. Legen Sie das Ausgabenlimit fest, bei dem die Werbekampagne gestoppt wird.',
		ru: '<b>Ваш бюджет</b>. Установите ограничение расхода. При достижении рекламная кампания остановится.',
		cn: '<b>您的预算</b>。设定费用上限，到达此上限时，广告活动即停止。'
	},
	max_bid: {
		en: 'max bid',
		ge: 'მაქსიმუმალური bid',
		de: 'Höchstgebot',
		ru: 'максимальная ставка',
		cn: '最高出价'
	},
	max_bid_hint: {
		en: '<div class=\'maximum_bid-hint\'>\n\t\t\t\t<p><b>Maximum BID</b>. The highest price an&nbsp;advertiser is&nbsp;willing to&nbsp;pay for Ad&nbsp;Plays, audience (OTS) or&nbsp;views. Depending on&nbsp;the target.</p>\n\t\t\t\t<p>The auction goes at&nbsp;each point of&nbsp;broadcasting at&nbsp;the time of&nbsp;possible playback of&nbsp;the campaign.</p>\n\t\t\t</div>',
		ge: '<div class=\'maximum_bid-hint\'>\n\t\t\t\t<p><b>მაქსიმალური BID</b>.ყველაზე მაღალი ფასი&nbsp;რეკლამის განმთავსებელი&nbsp;სურვილია&nbsp;გადაიხადოს Ad&nbsp;Plays, აუდიტორია (OTS) ან&nbsp;ნახვები. დამოკიდებულია&nbsp;სამიზნეზე.</p>\n\t\t\t\t<p>აუქციონი გადის&nbsp;მაუწყებლობის თითოეულ წერტილზე&nbsp;კამპანიის&nbsp;შესაძლო დაკვრის&nbsp;დროზე.</p>\n\t\t\t</div>',
		de: '<div class=\'maximum_bid-hint\'>\n\t\t\t\t<p><b>Höchstgebot</b>. Der höchste Preis, den ein&nbsp;Werbetreibender bereit ist, für Ad&nbsp;Plays, Zielgruppe (OTS) oder&nbsp;Aufrufe zu&nbsp;zahlen. Abhängig vom&nbsp;Ziel.</p>\n\t\t\t\t<p>Die Auktion findet an&nbsp;jedem Übertragungspunkt zum&nbsp;Zeitpunkt der möglichen Wiedergabe der Kampagne statt.</p>\n\t\t\t</div>',
		ru: '<div class=\'maximum_bid-hint\'>\n\t\t\t\t<p><b>Максимальная ставка</b>. Высшая цена, которую готов заплатить рекламодатель за&nbsp;воспроизведения, аудиторию (OTS) или просмотры. В&nbsp;зависимости от&nbsp;выбранной вами цели.</p>\n\t\t\t\t<p>Аукцион проходит на&nbsp;каждой точке вещания в&nbsp;момент возможного воспроизведения кампании.</p>\n\t\t\t</div>',
		cn: '<div class=\'maximum_bid-hint\'>\n\t\t\t\t<p><b>最高出价</b>。广告客户愿意为广告播放、受众（视听机会）或观看支付的最高价格。取决于具体目标。</p>\n\t\t\t\t<p>在每个播放点，每次即将播放广告时进行竞价。</p>\n\t\t\t</div>'
	},
	budget_more_than_balance: {
		en: 'Campaign budget exceeds advertising agency budget',
		ge: 'კამპანიის ბიუჯეტი აღემატება სარეკლამო სააგენტოს ბიუჯეტს',
		de: 'Das Kampagnenbudget übersteigt das Budget der Werbeagentur',
		ru: 'Бюджет кампании превышает бюджет рекламного агенства',
		cn: 'Campaign budget exceeds advertising agency budget' // TODO
	},
	insufficient_balance_request_dsp_view: {
		en: 'Top up your balance before submitting your request',
		ge: 'შეავსეთ ბალანსი თქვენი მოთხოვნის გაგზავნამდე',
		de: 'Laden Sie Ihr Guthaben auf, bevor Sie Ihre Anfrage einreichen',
		ru: 'Пополните баланс перед отправкой запроса',
		cn: 'Top up your balance before submitting your request' // TODO
	},
	insufficient_balance_dsp_view: {
		en: 'To continue the campaign, top up your balance',
		ge: 'კამპანიის გასაგრძელებლად შეავსეთ ბალანსი',
		de: 'Um die Kampagne fortzusetzen, laden Sie Ihr Guthaben auf',
		ru: 'Для продолжения кампании пополните баланс',
		cn: 'To continue the campaign, top up your balance' // TODO
	},
	insufficient_balance_ssp_view: {
		en: 'The DSP agency has a negative balance',
		ge: 'DSP სააგენტოს აქვს უარყოფითი ბალანსი',
		de: 'Das DSP-Agentur hat ein negatives Guthaben',
		ru: 'У DSP агентства отрицательный баланс',
		cn: 'The DSP agency has a negative balance' // TODO
	},
	sec: {
		en: 'sec',
		ge: 'წმ',
		de: 'Sek',
		ru: 'сек',
		cn: '秒'
	},
	seconds: {
		en: '0 seconds | 1 second | {n} seconds',
		ge: '0 წამი | 1 წამი | {n} წამი',
		de: '0 Sekunden | {n} Sekunde | {n} Sekunden',
		ru: '0 секунд | {n} cекунду | {n} секунды | {n} секунд',
		cn: '0 秒 | 1 秒 | {n} 秒'
	},
	seconds_won: {
		en: 'seconds | second | seconds',
		ge: 'წამები | წამი | წამები',
		de: 'Sekunden | Sekunde | Sekunden',
		ru: 'секунд | cекунду | секунды | секунд',
		cn: '秒 | 秒 | 秒'
	},
	days: {
		en: '0 days | 1 day | {n} days',
		ge: '0 დღე | 1 დღე | {n} დღე',
		de: '0 Tage | 1 Tag | {n} Tage',
		ru: '0 дней | {n} день | {n} дня | {n} дней',
		cn: '0 天 | 1 天 | {n} 天'
	},
	days_won: {
		en: 'days | day | days',
		ge: 'დღეები | დღე | დღეები',
		de: 'Tage | Tag | Tage',
		ru: 'дней | день | дня | дней',
		cn: '天 | 天 | 天'
	},
	model_phrase: {
		en: 'for a {seconds} creative',
		ge: '{seconds} შექმნაში',
		de: 'für eine {seconds} kreative',
		ru: 'при длительности креатива в {seconds}',
		cn: '持续时间为 {seconds} 秒的广告内容'
	},
	budget_desc_spend_to: {
		en: 'You`ll spend up to <b>{budget_to_spend}</b> for this line order.',
		ge: 'თქვენ დახარჯავთ <b>{budget_to_spend}</b>-მდე ამ შეკვეთისთვის',
		de: 'Sie werden bis zu <b>{budget_to_spend}</b> für diese Bestellung ausgeben.',
		ru: 'Вы потратите до <b>{budget_to_spend}</b> на этот заказ.',
		cn: '此订单的最高费用为 <b>{budget_to_spend}</b>。'
	},
	budget_desc_target_budget: {
		en: 'The estimated budget for your goal is <b>{target_budget}</b>',
		ge: 'თქვენი მიზნის სავარაუდო ბიუჯეტია  <b>{target_budget}</b>',
		de: 'Das geschätzte Budget für Ihr Ziel beträgt <b>{target_budget}</b>',
		ru: 'Предполагаемый бюджет для вашей цели &ndash; <b>{target_budget}</b>',
		cn: '要达成您的目标，预估费用为 <b>{target_budget}</b>'
	},
	budget_desc_max_budget: {
		en: 'The current maximum estimated budget for this line order is <b>{budget_max_limit}</b>',
		ge: 'ამ ხაზის შეკვეთის მიმდინარე მაქსიმალური სავარაუდო ბიუჯეტი არის <b>{budget_max_limit}</b>',
		de: 'Das aktuelle maximale geschätzte Budget für diese Bestellung beträgt <b>{budget_max_limit}</b>',
		ru: 'Текущий максимальный ожидаемый бюджет на этот заказ &ndash; <b>{budget_max_limit}</b>',
		cn: '此订单当前最高预估费用为 <b>{budget_max_limit}</b>'
	},
	bid_desc: {
		en: 'The effective bid range is&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.<br />Your max bid will be&nbsp;adjusted to&nbsp;your creative duration.',
		ge: 'ეფექტური შეთავაზების დიაპაზონი არის&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.<br />თქვენი მაქსიმალური შეთავაზება &nbsp;მოერგება&nbsp;თქვენს შემოქმედების ხანგრძლივობას',
		de: 'Der effektive Gebotsbereich beträgt&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.<br />Ihr Höchstgebot wird an&nbsp;die Dauer Ihres kreativen Inhalts angepasst.',
		ru: 'Эффективный диапазон ставок &mdash;&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.<br />Максимальная ставка основана на длительности креатива',
		cn: '最有效的出价区间为 <b>{min_price} 至 {max_price}</b>。<br />您的最高出价会随广告内容时长调整。'
	},
	bid_desc_short: {
		en: 'The effective bid range is&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.',
		ge: 'ეფექტური შეთავაზების დიაპაზონი არის&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.',
		de: 'Der effektive Gebotsbereich beträgt&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.',
		ru: 'Эффективный диапазон ставок &mdash;&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.',
		cn: '最有效的出价区间为 <b>{min_price} 至 {max_price}</b>。'
	},
	schedule: {
		en: 'schedule',
		ge: 'განრიგი',
		de: 'Zeitplan',
		ru: 'расписание',
		cn: '时间表'
	},
	max_bid_changed: {
		en: 'Max bid changed from {old} to {new}',
		ge: 'მაქსიმალური შეთავაზება შეიცვალა {old}-დან {new}',
		de: 'Höchstgebot von {old} auf {new} geändert',
		ru: 'Максимальная ставка изменилась с {old} на {new}',
		cn: '最高出价从 {old} 更改为 {new}'
	},
	campaign_name: {
		en: 'campaign name',
		ge: 'კამპანიის სახელი',
		de: 'Kampagnenname',
		ru: 'название кампании',
		cn: '活动名称'
	},
	campaign_name_placeholder: {
		en: 'enter campaign name',
		ge: 'შეიყვანეთ კამპანიის სახელ',
		de: 'Kampagnennamen eingeben',
		ru: 'введите название кампании',
		cn: '输入活动名称'
	},
	content_category_label: {
		en: 'content category',
		ge: 'შინაარსის კატეგორია',
		de: 'Inhaltskategorie',
		ru: 'категория контента',
		cn: '内容类别'
	},
	content_category_placeholder: {
		en: 'Choose category',
		ge: 'აირჩიე კატეგორია',
		de: 'Kategorie wählen',
		ru: 'выберите категорию',
		cn: '选择类别'
	},
	advertiser_label: {
		en: 'advertiser',
		ge: 'რეკლამის განმთავსებელი',
		de: 'Werbetreibender',
		ru: 'рекламодатель',
		cn: '广告客户'
	},
	advertiser_placeholder: {
		en: 'find and choose..',
		ge: 'იპოვე და აირჩიე..',
		de: 'finden und auswählen..',
		ru: 'поиск и выбор..',
		cn: '查找并选择..'
	},
	select_placeholder: {
		en: 'find...',
		ge: 'იპოვე...',
		de: 'finden...',
		ru: 'найти...',
		cn: '查找...'
	},
	step01_title: {
		en: 'request',
		ge: 'მოთხოვნა',
		de: 'Anfrage',
		ru: 'запрос',
		cn: '请求'
	},
	step02_title: {
		en: 'product',
		ge: 'პროდუქტი',
		de: 'Produkt',
		ru: 'продукт',
		cn: '产品'
	},
	step03_title: {
		en: 'order',
		ge: 'შეკვეთა',
		de: 'Bestellung',
		ru: 'заказ',
		cn: '订单'
	},
	step04_title: {
		en: 'creative',
		ge: 'შექმნა',
		de: 'Kreativ',
		ru: 'креатив',
		cn: '广告内容'
	},
	next_btn_label: {
		en: 'next',
		ge: 'შემდეგი',
		de: 'weiter',
		ru: 'далее',
		cn: '下一步'
	},
	back_btn_label: {
		en: 'back',
		ge: 'უკან',
		de: 'zurück',
		ru: 'назад',
		cn: '返回'
	},
	close_btn_label: {
		en: 'close',
		ge: 'დახურვა',
		de: 'schließen',
		ru: 'закрыть',
		cn: '关闭'
	},
	creative_text: {
		en: 'Creatives can be slightly cropped to accommodate suppliers’ screen specifications. We suggest to avoid positioning logos and text close to the edges. For best results, leave a 5% margin on each side.',
		ge: 'რეკლამის ზომები შეიძლება ოდნავ შემცირდეს მომწოდებლების ეკრანის სპეციფიკაციების დასაკმაყოფილებლად. ჩვენ გირჩევთ, მოერიდოთ ლოგოების და ტექსტის კიდეებთან ახლოს განთავსებას. საუკეთესო შედეგისთვის, დატოვეთ 5% ზღვარი თითოეულ მხარეს.',
		de: 'Kreative können leicht beschnitten werden, um den Spezifikationen der Bildschirme der Anbieter zu entsprechen. Wir empfehlen, Logos und Texte nicht zu nah an den Rändern zu platzieren. Für beste Ergebnisse lassen Sie einen Rand von 5% auf jeder Seite.',
		ru: 'Креативы могут быть слегка обрезаны по краям в соответствии со спецификациями экранов. Рекомендуется избегать размещения логотипов и текста близко к краям креатива. Для оптимального результата используйте отступ в 5% от размера формата.',
		cn: '广告内容可能会被稍稍裁切，以适应供应商的屏幕尺寸。我们建议不要将商标和文字放置在边缘处。为达到最佳效果，四边请各留出 5% 的空白。'
	},
	creative_full_spec_btn_label: {
		en: 'See the complete creative specs',
		ge: 'იხილეთ სრული შექმნის სპეციფიკაციები',
		de: 'Sehen Sie die vollständigen kreativen Spezifikationen',
		ru: 'Посмотреть полную спецификацию для креативов',
		cn: '查看广告内容的完整属性'
	},
	privacy_policies_line_01: {
		en: 'please review our',
		ge: 'გთხოვთ გადახედოთ ჩვენს',
		de: 'Bitte überprüfen Sie unsere',
		ru: 'Пожалуйста изучите наши',
		cn: '在提交之前'
	},
	privacy_policies_line_02: {
		en: 'creative policies',
		ge: 'შექმნის პოლიტიკა',
		de: 'kreativen Richtlinien',
		ru: 'регулирующие документы',
		cn: '请查看我们的'
	},
	privacy_policies_line_03: {
		en: 'before submitting',
		ge: 'გაგზავნამდე',
		de: 'vor dem Einreichen',
		ru: 'перед отправкой',
		cn: '广告内容政策'
	},
	place_order_btn_label: {
		en: 'place order',
		ge: 'განათავსეთ შეკვეთა',
		de: 'Bestellung aufgeben',
		ru: 'разместить запрос',
		cn: '提交订单'
	},
	save_as_draft_btn_label: {
		en: 'save as draft',
		ge: 'შენახვა როგორც მონახაზი',
		de: 'als Entwurf speichern',
		ru: 'сохранить как черновик',
		cn: '另存为草稿'
	},
	or: {
		en: 'or',
		ge: 'ან',
		de: 'oder',
		ru: 'или',
		cn: '或'
	},
	monitor: {
		en: 'screen',
		ge: 'ეკრანი',
		de: 'Bildschirm',
		ru: 'экран',
		cn: '屏幕'
	},
	other: {
		en: 'other',
		ge: 'სხვა',
		de: 'andere',
		ru: 'остальное',
		cn: '其他'
	},
	devices: {
		en: '0 devices | 1 device | {n} devices',
		ge: '0 მოწყობილობა | 1 მოწყობილობა | {n} მოწყობილობა',
		de: '0 Geräte | 1 Gerät | {n} Geräte',
		ru: '0 устройств | {n} устройство | {n} устройства | {n} устройств',
		cn: '0 台设备 | 1 台设备 | {n} 台设备'
	},
	upload_content_btn_label: {
		en: 'upload content',
		ge: 'ატვირთეთ შინაარსი',
		de: 'Inhalt hochladen',
		ru: 'загрузить контент',
		cn: '上传内容'
	},
	upload_doc_btn_label: {
		en: 'upload documents',
		ge: 'upload documents',
		de: 'upload documents',
		ru: 'загрузить документы',
		cn: 'upload documents'
	},
	choose_creative_btn_label: {
		en: 'choose',
		ge: 'არჩევა',
		de: 'wählen',
		ru: 'выбрать',
		cn: '选择'
	},
	no_creatives_issue: {
		en: 'Request without any creatives added could be saved only as a draft',
		ge: 'შექმნილის დამატების მოთხოვნის გარეშე ის შეინახება მხოლოდ მონახაზად',
		de: 'Anfrage ohne hinzugefügte kreative Inhalte kann nur als Entwurf gespeichert werden',
		ru: 'Запрос без креативов может быть сохранён только как черновик',
		cn: '没有添加任何广告内容的请求只能另存为草稿'
	},
	confirm_email: {
		en: 'Please, confirm the email before submitting your request',
		ge: 'გთხოვთ, დაადასტუროთ ელ.წერილი თქვენი მოთხოვნის გაგზავნამდე',
		de: 'Bitte bestätigen Sie die E-Mail, bevor Sie Ihre Anfrage einreichen',
		ru: 'Пожалуйста, подтвердите адрес электронной почты перед отправкой запроса',
		cn: 'Please, confirm the email before submitting your request' // TODO
	},
	video_resolution: {
		en: 'video resolution',
		ge: 'ვიდეო გარჩევადობა',
		de: 'Videoauflösung',
		ru: 'Разрешение видео',
		cn: '视频分辨率'
	},
	video_duration: {
		en: 'video duration',
		ge: 'ვიდეოს ხანგრძლივობა',
		de: 'Videodauer',
		ru: 'Длительность видео',
		cn: '视频时长'
	},
	screen_resolution: {
		en: 'screen resolution',
		ge: 'ეკრანის გარჩევადობა',
		de: 'Bildschirmauflösung',
		ru: 'разрешение устройства',
		cn: '屏幕分辨率'
	},
	current_status: {
		en: 'current status',
		ge: 'მიმდინარე სტატუსი',
		de: 'Aktueller Status',
		ru: 'текущий статус',
		cn: '当前状态'
	},
	audit_message: {
		en: 'audit message',
		ge: 'ხდება შეტყობინების შემოწმდება',
		de: 'Auditnachricht',
		ru: 'аудит',
		cn: '审核消息'
	},
	resolution: {
		en: 'resolution',
		ge: 'რეზოლუცია',
		de: 'Auflösung',
		ru: 'разрешение',
		cn: '分辨率'
	},
	duration: {
		en: 'duration',
		ge: 'ხანგრძლივობა',
		de: 'Dauer',
		ru: 'длительность',
		cn: '时长'
	},
	file_size: {
		en: 'file size',
		ge: 'ფაილის ზომა',
		de: 'Dateigröße',
		ru: 'размер файла',
		cn: '文件大小'
	},
	'delete': {
		en: 'delete',
		ge: 'delete',
		de: 'löschen',
		ru: 'удалить',
		cn: '删除'
	},
	cancel: {
		en: 'cancel',
		ge: 'გაუქმება',
		de: 'abbrechen',
		ru: 'отменить',
		cn: '取消'
	},
	edit: {
		en: 'edit',
		ge: 'დეტალები',
		de: 'bearbeiten',
		ru: 'изменить',
		cn: '编辑'
	},
	details: {
		en: 'details',
		ge: 'details',
		de: 'Details',
		ru: 'подробности',
		cn: '详情'
	},
	upload: {
		en: 'upload',
		ge: 'ატვირთვა',
		de: 'hochladen',
		ru: 'загрузить',
		cn: '上传'
	},
	uploaded: {
		en: 'uploaded',
		ge: 'ატვირთული',
		de: 'hochgeladen',
		ru: 'загружено',
		cn: '已上传'
	},
	cancel_uploading: {
		en: 'cancel uploading',
		ge: 'ატვირთვის გაუქმება',
		de: 'Hochladen abbrechen',
		ru: 'остановить загрузку',
		cn: '取消上传'
	},
	edit_details: {
		en: 'edit details',
		ge: 'დეტალების რედაქტირება',
		de: 'Details bearbeiten',
		ru: 'редактировать',
		cn: '编辑详情'
	},
	see_details: {
		en: 'see details',
		ge: 'იხილეთ დეტალები',
		de: 'Details ansehen',
		ru: 'подробнee',
		cn: '查看详情'
	},
	created_by: {
		en: 'created by',
		ge: 'შექმნილი',
		de: 'erstellt von',
		ru: 'разместил',
		cn: '创建者'
	},
	uploaded_by: {
		en: 'uploaded by',
		ge: 'ატვირთული',
		de: 'hochgeladen von',
		ru: 'загрузил',
		cn: '上传者'
	},
	creative_status_waiting: {
		en: 'waiting',
		ge: 'ვლოდებია',
		de: 'wartet',
		ru: 'ожидание',
		cn: '正在等待'
	},
	creative_status_canceled: {
		en: 'canceled',
		ge: 'გაუქმდა',
		de: 'abgebrochen',
		ru: 'отменен',
		cn: '已取消'
	},
	creative_status_uploading: {
		en: 'uploading',
		ge: 'ატვირთვა',
		de: 'lädt hoch',
		ru: 'загружается',
		cn: '正在上传'
	},
	creative_status_uploaded: {
		en: 'uploaded',
		ge: 'ატვირთული',
		de: 'hochgeladen',
		ru: 'загружено',
		cn: '已上传'
	},
	creative_status_failed: {
		en: 'failed',
		ge: 'ჩაიშალა',
		de: 'fehlgeschlagen',
		ru: 'неудача',
		cn: '失败'
	},
	creative_audit_status_pending_audit: {
		en: 'pending audit',
		ge: 'ელოდება შემოწმებას',
		de: 'Audit ausstehend',
		ru: 'ожидается аудит',
		cn: '正在审核'
	},
	creative_audit_status_pre_approved: {
		en: 'pre approved',
		ge: 'წინასწარ დამტკიცებული',
		de: 'vorab genehmigt',
		ru: 'предварительно одобрено',
		cn: '已预审批'
	},
	creative_audit_status_approved: {
		en: 'approved',
		ge: 'დამტკიცებული',
		de: 'genehmigt',
		ru: 'одобрено',
		cn: '已审批'
	},
	creative_audit_status_rejected: {
		en: 'rejected',
		ge: 'უარყოფილი',
		de: 'abgelehnt',
		ru: 'отклонено',
		cn: '已驳回'
	},
	creative_audit_status_changed: {
		en: 'changed',
		ge: 'შეცვლილი',
		de: 'geändert',
		ru: 'изменено',
		cn: '已更改'
	},
	creative_audit_status_expired: {
		en: 'expired',
		ge: 'ვადაგასული',
		de: 'abgelaufen',
		ru: 'устарело',
		cn: '已过期'
	},
	// TODO: translation needed
	status_resetting_reason: {
		en: 'status pending reason',
		ge: 'სტატუსის მომლოდინე მიზეზი',
		de: 'Status ausstehender Grund',
		ru: 'причина ожидания подтверждения',
		cn: '状态为正在审核的原因'
	},
	pending_reason: {
		en: 'status pending reason',
		ge: 'სტატუსის მომლოდინე მიზეზი',
		de: 'Status ausstehender Grund',
		ru: 'причина ожидания подтверждения',
		cn: '状态为正在审核的原因'
	},
	pre_approvement_reason: {
		en: 'pre approvement',
		ge: 'წინასწარ დამტკიცება',
		de: 'Vorabgenehmigung',
		ru: 'причина предварительного подтверждения',
		cn: '预审批'
	},
	approvement_reason: {
		en: 'approvement reason',
		ge: 'დამტკიცების მიზეზი',
		de: 'Genehmigungsgrund',
		ru: 'причина подтверждения',
		cn: '审批原因'
	},
	rejection_reason: {
		en: 'rejection reason',
		ge: 'უარის მიზეზი',
		de: 'Ablehnungsgrund',
		ru: 'причина отказа',
		cn: '驳回原因'
	},
	resubmition_requirement_reason: {
		en: 'resubmition requirement reason',
		ge: 'ხელახლა წარდგენის მოთხოვნის მიზეზი',
		de: 'Gründe für die erneute Einreichung',
		ru: 'причина повторной отправки',
		cn: '要求重新提交的原因'
	},
	expiration_reason: {
		en: 'expiration reason',
		ge: 'გადასვლის მიზეზი',
		de: 'Ablaufgrund',
		ru: 'причина истечения срока ',
		cn: '过期原因'
	},
	of: {
		en: 'of',
		ge: 'დან',
		de: 'von',
		ru: '',
		cn: '的'
	},
	reset_to_pending: {
		en: 'reset to pending',
		ge: 'მოლოდინში დაყენება',
		de: 'Zurücksetzen auf ausstehend',
		ru: 'сбросить на ожидание',
		cn: '重置为正在审核'
	},
	creative_audit_action_reset_to_pending: {
		en: 'reset to pending',
		ge: 'მოლოდინში დაყენება',
		de: 'Zurücksetzen auf ausstehend',
		ru: 'сбросить на ожидание',
		cn: '重置为正在审核'
	},
	creative_audit_action_pre_approve: {
		en: 'pre approve',
		ge: 'წინასწარ დამტკიცება',
		de: 'vorab genehmigen',
		ru: 'предварительно подтвердить',
		cn: '预审批'
	},
	creative_audit_action_approve: {
		en: 'approve',
		ge: 'დამტკიცება',
		de: 'genehmigen',
		ru: 'подтвердить',
		cn: '审批'
	},
	creative_audit_action_reject: {
		en: 'reject',
		ge: 'უარი',
		de: 'ablehnen',
		ru: 'отклонить',
		cn: '驳回'
	},
	creative_audit_action_require_resubmition: {
		en: 'require resubmition',
		ge: 'მოითხოვე ხელახლა გაგზავნა',
		de: 'erneute Einreichung erforderlich',
		ru: 'запросить повторную отправку',
		cn: '要求重新提交'
	},
	creative_audit_action_set_to_expired: {
		en: 'set to expired',
		ge: 'დაყენებულია ვადაგასულად',
		de: 'als abgelaufen markieren',
		ru: 'пометить как просроченный',
		cn: '设置为已过期'
	},
	changed: {
		en: 'changed',
		ge: 'შეცვლილი',
		de: 'geändert',
		ru: 'изменено',
		cn: '已更改'
	},
	changed_by: {
		en: 'changed by',
		ge: 'შეცვლილია',
		de: 'geändert von',
		ru: 'изменил',
		cn: '更改者'
	},
	creative_audit_action_noun_status_resetting: {
		en: 'reset to pending',
		ge: 'მოლოდინში დაყენებ',
		de: 'Zurücksetzen auf ausstehend',
		ru: 'сбросить на ожидание',
		cn: '重置为正在审核'
	},
	creative_audit_action_noun_pre_approvement: {
		en: 'pre approvement',
		ge: 'წინასწარ დამტკიცებაt',
		de: 'Vorabgenehmigung',
		ru: 'предварительное подтверждение',
		cn: '预审批'
	},
	creative_audit_action_noun_approvement: {
		en: 'approvement',
		ge: 'დამტკიცება',
		de: 'Genehmigung',
		ru: 'подтверждение',
		cn: '审批'
	},
	creative_audit_action_noun_rejection: {
		en: 'rejection',
		ge: 'უარი',
		de: 'Ablehnung',
		ru: 'отклонение',
		cn: '驳回'
	},
	creative_audit_action_noun_resubmition_requirement: {
		en: 'resubmition requirement',
		ge: 'მოითხოვე ხელახლა გაგზავნა',
		de: 'Erneute Einreichung erforderlich',
		ru: 'запрос повторной отправки',
		cn: '重新提交要求'
	},
	creative_audit_action_noun_expiration: {
		en: 'expiration',
		ge: 'ვადის გასვლა',
		de: 'Ablauf',
		ru: 'истечение',
		cn: '过期'
	},
	// pre_approved
	status_change_2: {
		en: 'pre approved',
		ge: 'წინასწარ დამტკიცებული',
		de: 'vorab genehmigt',
		ru: 'предварительно утверждено',
		cn: /* TODO: to be translated */'pre approved'
	},
	// old?
	status_change_approved: {
		en: 'approved',
		ge: 'დამტკიცებული',
		de: 'genehmigt',
		ru: 'подтверждено',
		cn: '已审批'
	},
	// pre_approved
	pre_approve: {
		en: 'pre approve',
		ge: 'წინასწარ დამტკიცება',
		de: 'vorab genehmigen',
		ru: 'предварительно утвердить',
		cn: /* TODO: to be translated */'pre approve'
	},
	status_change_2_action: {
		en: 'pre approve',
		ge: 'წინასწარ დამტკიცება',
		de: 'vorab genehmigen',
		ru: 'предварительно утвердить',
		cn: /* TODO: to be translated */'pre approve'
	},
	// playing
	status_change_3: {
		en: 'playing',
		ge: 'ჩართვა',
		de: 'wird abgespielt',
		ru: 'проигрывается',
		cn: '正在播放'
	},
	status_change_531: {
		en: 'awaiting approval',
		ge: 'დამტკიცების მოლოდინში',
		de: 'Warten auf Genehmigung',
		ru: 'ожидание подтверждения',
		cn: '正在等待审批'
	},
	status_change_532: {
		en: 'playing only approved',
		ge: 'ჩართულია მხოლოდ დამტკიცებული',
		de: 'nur genehmigte werden abgespielt',
		ru: 'проигрываются только подтвержденные',
		cn: 'playing only approved'
	},
	// playing
	status_change_3_action: {
		en: 'to playing',
		ge: 'ჩართვა',
		de: 'abspielen',
		ru: 'запустить',
		cn: '播放'
	},
	// paused
	status_change_692: {
		en: 'paused',
		ge: 'შეჩერებულია',
		de: 'pausiert',
		ru: 'приостановлено',
		cn: '已暂停'
	},
	// paused
	status_change_692_action: {
		en: 'pause',
		ge: 'პაუზა',
		de: 'pausieren',
		ru: 'приостановить',
		cn: '暂停'
	},
	// finished
	status_change_693: {
		en: 'finished',
		ge: 'დასრულებულია',
		de: 'beendet',
		ru: 'завершено',
		cn: '已完成'
	},
	// finished
	status_change_693_action: {
		en: 'finish',
		ge: 'დასრულება',
		de: 'beenden',
		ru: 'завершить',
		cn: '完成'
	},
	// awaiting_approval
	status_change_1: {
		en: 'awaiting approval',
		ge: 'ელოდებია დამტკიცებას',
		de: 'Warten auf Genehmigung',
		ru: 'ожидание подтверждения',
		cn: '正在等待审批'
	},
	// awaiting_approval
	status_change_1_action: {
		en: 'send to approve',
		ge: 'გაგზავნა დასამტკიცებლად',
		de: 'zur Genehmigung senden',
		ru: 'отправить на подтверждение',
		cn: '发送审批请求'
	},
	// rejected
	status_change_4: {
		en: 'rejected',
		ge: 'უარყოფილი',
		de: 'abgelehnt',
		ru: 'отклонено',
		cn: '已驳回'
	},
	// rejected
	status_change_4_action: {
		en: 'reject',
		ge: 'უარი',
		de: 'ablehnen',
		ru: 'отклонить',
		cn: '驳回'
	},
	// archived
	status_change_694: {
		en: 'archived',
		ge: 'არქივირებული',
		de: 'archiviert',
		ru: 'в архиве',
		cn: '已存档'
	},
	// archived
	status_change_694_action: {
		en: 'archive',
		ge: 'არქივი',
		de: 'archivieren',
		ru: 'архивировать',
		cn: '存档'
	},
	// deleted
	status_change_695: {
		en: 'deleted',
		ge: 'წაშლილი',
		de: 'gelöscht',
		ru: 'удалено',
		cn: '已删除'
	},
	// deleted
	status_change_695_action: {
		en: 'delete',
		ge: 'წაშლა',
		de: 'löschen',
		ru: 'удалить',
		cn: '删除'
	},
	all_campaigns: {
		en: 'all campaigns',
		ge: 'ყველა კამპანია',
		de: 'alle Kampagnen',
		ru: 'все кампании',
		cn: '所有活动'
	},
	campaigns: {
		en: 'campaigns',
		ge: 'კამპანიები',
		de: 'Kampagnen',
		ru: 'кампании',
		cn: /* TODO: to be translated */'campaigns',
	},
	status_change_draft: {
		en: 'draft',
		ge: 'მონახაზი',
		de: 'Entwurf',
		ru: 'черновик',
		cn: '草稿'
	},
	status_change_reviewing: {
		en: 'reviewing',
		ge: 'მიმოხილვა',
		de: 'wird überprüft',
		ru: 'пересматривается',
		cn: '正在审阅'
	},
	status_change_failed: {
		en: 'status change failed',
		ge: 'სტატუსის შეცვლა ვერ მოხერხდა',
		de: 'Statusänderung fehlgeschlagen',
		ru: 'не удалось изменить статус',
		cn: '无法更改状态'
	},
	request_review_subtitle: {
		en: 'From {company} by {manager}',
		ge: '{company}დან {manager}ის მიერ',
		de: 'Von {company} durch {manager}',
		ru: 'Создано {company}, пользователем {manager}',
		cn: '审阅人：{company} {manager}'
	},
	play: {
		en: 'play',
		ge: 'ჩართვა',
		de: 'abspielen',
		ru: 'запустить',
		cn: '播放'
	},
	pause: {
		en: 'pause',
		ge: 'პაუზა',
		de: 'pausieren',
		ru: 'приостановить',
		cn: '暂停'
	},
	approve: {
		en: 'approve',
		ge: 'დამტკიცება',
		de: 'genehmigen',
		ru: 'принять',
		cn: '审批'
	},
	reject: {
		en: 'reject',
		ge: 'უარი',
		de: 'ablehnen',
		ru: 'отклонить',
		cn: '驳回'
	},
	archive: {
		en: 'archive',
		ge: 'არქივი',
		de: 'archivieren',
		ru: 'архивировать',
		cn: '存档'
	},
	details_tab: {
		en: 'details',
		ge: 'დეტალები',
		de: 'Details',
		ru: 'подробности',
		cn: '详情'
	},
	order_tab: {
		en: 'order',
		ge: 'შეკვეთა',
		de: 'Bestellung',
		ru: 'заказ',
		cn: '订单'
	},
	creative_tab: {
		en: 'creative',
		ge: 'შემოქმედება',
		de: 'Kreativ',
		ru: 'креатив',
		cn: '广告内容'
	},
	status_tab: {
		en: 'status',
		ge: 'სტატუსი',
		de: 'Status',
		ru: 'статус',
		cn: '状态'
	},
	history_tab: {
		en: 'Changes',
		ge: 'Changes',
		de: 'Changes',
		ru: 'Изменения',
		cn: 'Changes'
	},
	seller_name: {
		en: 'seller\'s name',
		ge: 'გამყიდველის სახელი',
		de: 'Name des Verkäufers',
		ru: 'рекламодатель',
		cn: '销售商名称'
	},
	contact_number: {
		en: 'contact number',
		ge: 'საკონტაქტო ნომერი',
		de: 'Kontaktnummer',
		ru: 'номер для связи',
		cn: '联系电话'
	},
	client_id: {
		en: 'client id (contract)',
		ge: 'კლიენტის ID  (კონტრაქტი)',
		de: 'Kunden-ID (Vertrag)',
		ru: 'контракт',
		cn: '客户 ID（合同）'
	},
	email: {
		en: 'email',
		ge: 'ელფოსტა',
		de: 'E-Mail',
		ru: 'email',
		cn: '电子邮箱'
	},
	description: {
		en: 'description',
		ge: 'აღწერილობა',
		de: 'Beschreibung',
		ru: 'описание',
		cn: '描述'
	},
	description_placeholder: {
		en: 'description',
		ge: 'აღწერილობა',
		de: 'Beschreibung',
		ru: 'описание',
		cn: /* TODO: to be translated */ 'description',
	},
	brand_placeholder: {
		en: 'brand',
		ge: 'ბრენდი',
		de: 'Marke',
		ru: 'бренд',
		cn: /* TODO: to be translated */ 'brand',
	},
	brand_label: {
		en: 'brand',
		ge: 'ბრენდი',
		de: 'Marke',
		ru: 'бренд',
		cn: /* TODO: to be translated */ 'brand',
	},
	ad_duration: {
		en: 'ad duration',
		ge: 'რეკლამის ხანგრძლივობა',
		de: 'Anzeigendauer',
		ru: 'длительность',
		cn: '广告时长'
	},
	company: {
		en: 'company',
		ge: 'კომპანია',
		de: 'Firma',
		ru: 'компания',
		cn: '公司'
	},
	industry: {
		en: 'industry',
		ge: 'ინდუსტრია',
		de: 'Industrie',
		ru: 'индустрия',
		cn: '行业'
	},
	all: {
		en: 'all',
		ge: 'ყველა',
		de: 'alle',
		ru: 'все',
		cn: '全部'
	},
	max_bid_extra_detail: {
		en: 'for a {message_duration} creative',
		ge: '{message_duration} შექმნისთვის',
		de: 'für ein {message_duration} Kreativ',
		ru: 'для креатива в {message_duration}',
		cn: '针对时长为 {message_duration} 的广告内容'
	},
	widget_ad_plays_title: {
		en: 'Ad Plays',
		ge: 'რეკლამის გაშვება',
		de: 'Ad Plays',
		ru: 'Показы',
		cn: '广告播放'
	},
	widget_impressions_title: {
		en: 'Impressions',
		ge: 'შთაბეჭდილებები',
		de: 'Impressionen',
		ru: 'Охват',
		cn: '展示'
	},
	widget_inventory_title: {
		en: 'Inventory',
		ge: 'ინვენტარი',
		de: 'Inventar',
		ru: 'Точки вещания',
		cn: '清单'
	},
	widget_budget_label: {
		en: 'ordered',
		ge: 'შეკვეთა',
		de: 'bestellt',
		ru: 'забронировано',
		cn: '已提交订单'
	},
	widget_ad_plays_hint: {
		en: 'This is the forecast ad&nbsp;plays quantity that based on your rules and budget.',
		ge: 'ეს არის რეკლამის პროგნოზირება&nbsp;თამაშების რაოდენობა, რომელიც ეფუძნება თქვენს წესებსა და ბიუჯეტს.',
		de: 'Dies ist die prognostizierte Anzahl der Anzeigenschaltungen basierend auf Ihren Regeln und Ihrem Budget.',
		ru: 'Прогноз на количество показов для выбранных правил и бюджета.',
		cn: '这是根据您的规则和预算预测的广告播放次数。'
	},
	widget_ad_plays_max_hint: {
		en: 'This is the maximum ad plays quantity that based on your rules and in case of maximum budget.',
		ge: 'ეს არის რეკლამის დაკვრის მაქსიმალური რაოდენობა, რომელიც ეფუძნება თქვენს წესებს და მაქსიმალური ბიუჯეტის შემთხვევაში.',
		de: 'Dies ist die maximale Anzahl der Anzeigenschaltungen basierend auf Ihren Regeln und bei maximalem Budget.',
		ru: 'Возможный максимум показов для выбранных правил при максимальном бюджете.',
		cn: '这是根据您的规则，在预算达到上限时广告最多播放的次数。'
	},
	widget_budgeted_label: {
		en: 'ordered',
		ge: 'ბრძანება',
		de: 'bestellt',
		ru: 'забронировано',
		cn: '已提交订单'
	},
	widget_impressions_hint: {
		en: 'This is the forecast impressions that based on your rules and budget.',
		ge: 'ეს არის შთაბეჭდილებების პროგნოზი, რომელიც ეფუძნება თქვენს წესებსა და ბიუჯეტს.',
		de: 'Dies sind die prognostizierten Impressionen basierend auf Ihren Regeln und Ihrem Budget.',
		ru: 'Прогноз аудитории для выбранных правил и бюджета.',
		cn: '这是根据您的规则和预算预测的展示次数。'
	},
	widget_impressions_max_hint: {
		en: 'This is the maximum impressions that based on your rules and in case of maximum budget.',
		ge: 'ეს არის მაქსიმალური შთაბეჭდილებები, რაც გამომდინარეობს თქვენი წესებიდან მაქსიმალური ბიუჯეტის შემთხვევაში.',
		de: 'Dies sind die maximalen Impressionen basierend auf Ihren Regeln und bei maximalem Budget.',
		ru: 'Максимально возможная аудитория для выбранных правил при максимальном бюджете.',
		cn: '这是根据您的规则，在预算达到上限时的最多展示次数。'
	},
	widget_selected_label: {
		en: 'selected',
		ge: 'შერჩეული',
		de: 'ausgewählt',
		ru: 'выбрано',
		cn: '已选择'
	},
	widget_inventory_hint: {
		en: 'Broadcast points quantity accessible for this campaign. Based on your rules and budget.',
		ge: 'სამაუწყებლო წერტილების რაოდენობა ხელმისაწვდომია ამ კამპანიისთვის. თქვენი წესებისა და ბიუჯეტიდან გამომდინარე.',
		de: 'Anzahl der Übertragungspunkte, die für diese Kampagne zugänglich sind. Basierend auf Ihren Regeln und Ihrem Budget.',
		ru: 'Точек вещания доступных для этой кампании. Основано на выбранных правилах и бюджете.',
		cn: '这是根据您的规则和预算，此活动可以投放的播放点数量。'
	},
	widget_inventory_max_hint: {
		en: 'All accessible broadcast points quantity based on your rules and in case of maximum budget.',
		ge: 'ყველა ხელმისაწვდომი სამაუწყებლო წერტილების რაოდენობა თქვენი წესების მიხედვით და მაქსიმალური ბიუჯეტის შემთხვევაში.',
		de: 'Alle zugänglichen Übertragungspunkte basierend auf Ihren Regeln und bei maximalem Budget.',
		ru: 'Все доступные точки вещания доступные при выбранных правилах в случае максимального бюджета.',
		cn: '这是根据您的规则，在预算达到上限时可以投放的所有播放点数量。'
	},
	widget_requirements_label: {
		en: 'Creative Requirement',
		ge: 'შექმნის მოთხოვნა',
		de: 'Kreative Anforderung',
		ru: 'Форматы',
		cn: '广告内容要求'
	},
	widget_specs: {
		en: 'specs',
		ge: 'სპეციფიკაციები',
		de: 'Spezifikationen',
		ru: 'разрешения',
		cn: '属性'
	},
	widget_points: {
		en: 'points',
		ge: 'წერტილები',
		de: 'Punkte',
		ru: 'точки вещания',
		cn: '点'
	},
	available: {
		en: 'available',
		ge: 'ხელმისაწვდომია',
		de: 'verfügbar',
		ru: 'доступно',
		cn: '可用'
	},
	points: {
		en: 'points',
		ge: 'წერტილები',
		de: 'Punkte',
		ru: 'точки',
		cn: '点'
	},
	impressions: {
		en: 'impressions',
		ge: 'შთაბეჭდილებები',
		de: 'Impressionen',
		ru: 'аудитория',
		cn: '展示'
	},
	ad_plays: {
		en: 'Ad plays',
		ge: 'რეკლამის ჩართვა',
		de: 'Ad Plays',
		ru: 'Показы',
		cn: '广告播放'
	},
	sel_impressions: {
		en: 'impressions',
		ge: 'შთაბეჭდილებები',
		de: 'Impressionen',
		ru: 'аудитория',
		cn: '展示'
	},
	sel_spent: {
		en: 'spent',
		ge: 'დახარჯული',
		de: 'ausgegeben',
		ru: 'потрачено',
		cn: '已花费'
	},
	sel_ad_plays: {
		en: 'ad_plays',
		ge: 'რეკლამის ჩართვა',
		de: 'Anzeigenschaltungen',
		ru: 'показов',
		cn: '广告播放'
	},
	no_creative_specified: {
		en: 'No creative specified',
		ge: 'შექმნილები არ არის მითითებული',
		de: 'Kein kreativer Inhalt angegeben',
		ru: 'Нет прикреплённых креативов',
		cn: '没有指定广告内容'
	},
	step04_no_devices: {
		en: 'No devices are matching the filter',
		ge: 'არცერთი მოწყობილობა არ ემთხვევა ფილტრს',
		de: 'Keine Geräte entsprechen dem Filter',
		ru: 'Нет устройств, удовлетворяющих фильтру',
		cn: '没有符合筛选条件的设备'
	},
	download_broadcasting_report: {
		en: 'Broadcasting report',
		ge: 'მაუწყებლობის ანგარიში',
		de: 'Übertragungsbericht',
		ru: 'Эфирная справка',
		cn: '播放报告'
	},
	download_campaign_report: {
		en: 'Campaign report',
		ge: 'Campaign report',
		de: 'Campaign report',
		ru: 'Отчет о кампаниях',
		cn: 'Campaign report'
	},
	report_generation_started: {
		en: 'Report generation started. You will recieve an email when it is done.',
		ge: 'ანგარიშების შექმნა დაიწყო. თქვენ მიიღებთ ელ.წერილს, როდესაც ეს დასრულდება.',
		de: 'Berichtsgenerierung gestartet. Sie erhalten eine E-Mail, wenn dies abgeschlossen ist.',
		ru: 'Отчет генерируется. Вы получите уведомление на почту, когда он будет готов.',
		cn: '开始生成报告。报告生成完毕后您将收到电子邮件。'
	},
	report_generation_failed: {
		en: 'Report generation failed! Please, try again later.',
		ge: 'ანგარიშის შექმნა ვერ მოხერხდა! გთხოვთ, სცადოთ მოგვიანებით.',
		de: 'Berichtsgenerierung fehlgeschlagen! Bitte versuchen Sie es später noch einmal.',
		ru: 'Не удалось сгенерировать ответ. Пожалуйста, попробуйте позже.',
		cn: /* TODO: to be translated */'Report generation failed! Please, try again later.'
	},
	clear_selection_confirmation_text: {
		en: 'Are you sure you want to clear selected options?',
		ge: 'დარწმუნებული ხართ, რომ გსურთ არჩეული ვარიანტების გასუფთავება?',
		de: 'Sind Sie sicher, dass Sie die ausgewählten Optionen löschen möchten?',
		ru: 'Вы уверены, что хотите очистить выбранные опции?',
		cn: 'Are you sure you want to clear selected options?'  // TODO: translation needed
	},
	open_inventory_modal: {
		en: /* TODO: to be translated */'Show inventory details',
		ge: 'ინვენტარის დეტალების ჩვენება',
		de: 'Inventardetails anzeigen',
		ru: 'Показать точки вещания',
		cn: /* TODO: to be translated */'Show inventory details',
	},
	inventory_modal_hint: {
		en: /* TODO: to be translated */'See the platform\'s broadcasting points, control a black-/whitelist, export request\'s broadcasting point\'s list',
		ge: 'იხილეთ პლატფორმის სამაუწყებლო წერტილები, აკონტროლეთ შავი/თეთრი სია, მოთხოვნის ექსპორტის სამაუწყებლო პუნქტის სია',
		de: 'Sehen Sie die Übertragungspunkte der Plattform, verwalten Sie eine schwarze/weiße Liste, exportieren Sie die Liste der Übertragungspunkte der Anfrage',
		ru: 'Просмотр устройств платформы, управление чёрным и белым списком, экспорт списка устройств',
		cn: /* TODO: to be translated */ null,
	},
	campaign_edit: {
		en: 'Edit campaign',
		ge: 'კამპანიის რედაქტირება',
		de: 'Kampagne bearbeiten',
		ru: 'Редактировать кампанию',
		cn: /* TODO: to be translated */ 'Edit campaign',
	},
	fixed_placement: {
		en: 'Fixed placement without auction',
		ge: 'ფიქსირებული განთავსება აუქციონის გარეშე',
		de: 'Feste Platzierung ohne Auktion',
		ru: 'Фиксированное размещение без аукциона',
		cn: /* TODO: to be translated */ 'Fixed placement without auction',
	},
	fixed_cost: {
		en: 'Fixed cost',
		ge: 'ფიქსირებული ღირებულება',
		de: 'Feste Kosten',
		ru: 'Фиксированная цена',
		cn: /* TODO: to be translated */ 'Fixed cost',
	},
	fixed_placement_hint: {
		en: 'You can buy ads with a reservation at a fixed price for a thousand impressions (CPT or Ad plays), a thousand contacts (CPM), a set number of guaranteed views (CPV). If you select this option, the campaign will be played without participating in the auction. With the help of reservation, you can increase brand awareness, offer a new product or service, as well as a rebrand.',
		ge: 'შეგიძლიათ იყიდოთ რეკლამები, დაჯავშნით ფიქსირებულ ფასად, ათასი შთაბეჭდილებისთვის (CPT ან რეკლამის დაკვრა), ათასი კონტაქტის (CPM), გარანტირებული ნახვების დადგენილ რაოდენობაზე (CPV). თუ აირჩევთ ამ ვარიანტს, კამპანია იმუშავებს აუქციონში მონაწილეობის გარეშე. დაჯავშნის დახმარებით შეგიძლიათ გაზარდოთ ბრენდის ცნობადობა, შესთავაზოთ ახალი პროდუქტი ან სერვისი.',
		de: 'Sie können Anzeigen mit einer Reservierung zu einem festen Preis für tausend Impressionen (CPT oder Ad plays), tausend Kontakte (CPM), eine festgelegte Anzahl garantierter Aufrufe (CPV) kaufen. Wenn Sie diese Option auswählen, wird die Kampagne ohne Teilnahme an der Auktion abgespielt. Mit Hilfe der Reservierung können Sie die Markenbekanntheit steigern, ein neues Produkt oder eine neue Dienstleistung anbieten sowie ein Rebranding durchführen.',
		ru: 'Вы можете покупать рекламу с резервированием по фиксированной цене за: тысячу показов (CPT или Ad plays), тысячу контактов (CPM), установленное количество гарантированных просмотров (CPV). При выборе этой опции кампания будет проигрываться без участия в аукционе. С помощью резервирования можно повысить узнаваемость бренда, предложить новый товар или услугу, а также провести ребрендинг. ',
		cn: /* TODO: to be translated */ 'You can buy ads with a reservation at a fixed price for a thousand impressions (CPT or Ad plays), a thousand contacts (CPM), a set number of guaranteed views (CPV). If you select this option, the campaign will be played without participating in the auction. With the help of reservation, you can increase brand awareness, offer a new product or service, as well as a rebrand.',
	},
	per_day: {
		en: 'Per day',
		ge: 'დღეში',
		de: 'Pro Tag',
		ru: 'В день',
		cn: /* TODO: to be translated */ 'Per day',
	},
	impressions_per_day: {
		en: 'Total impressions per day',
		ge: 'მთლიანი შთაბეჭდილებები დღეში',
		de: 'Gesamtimpressionen pro Tag',
		ru: 'Всего показов в день',
		cn: /* TODO: to be translated */ 'Total impressions per day',
	},
	impressions_per_day_hint: {
		en: 'The number of impressions per day is calculated based on the parameters you selected.',
		ge: 'დღეში ჩვენებების რაოდენობა გამოითვლება თქვენ მიერ არჩეული პარამეტრების მიხედვით.',
		de: 'Die Anzahl der Impressionen pro Tag wird basierend auf den von Ihnen ausgewählten Parametern berechnet.',
		ru: 'Количество показов в день рассчитано на основе выбранных вами параметров.',
		cn: /* TODO: to be translated */ 'The number of impressions per day is calculated based on the parameters you selected.',
	},
	impressions_total_with_days_of_week_hint: {
		en: 'Accounting for selected days of week',
		ge: 'კვირის შერჩეული დღეების აღრიცხვა',
		de: 'Berücksichtigung der ausgewählten Wochentage',
		ru: 'С учетом ограничений по дням недели',
		cn: /* TODO: to be translated */ 'Accounting for selected days of week',
	},
	balance_ssp_hint: {
		en: 'Revenue from your SSP account.',
		ge: 'შემოსავლები თქვენი SSP ანგარიშიდან.',
		de: 'Einnahmen von Ihrem SSP-Konto.',
		ru: 'Выручка вашего SSP аккаунта с программатик продаж рекламы.',
		cn: /* TODO: to be translated */ 'Revenue from your SSP account.',
	},
	requests_ssp_hint: {
		en: 'Requests from programmatic buyers by status. The faster you will approve and transferred to the “Campaign " status, the more money you will earn.',
		ge: 'მოთხოვნები პროგრამის მყიდველებისგან სტატუსის მიხედვით. რაც უფრო სწრაფად დაამტკიცებთ და გადარიცხავთ „კამპანიის“ სტატუსს, მით მეტ ფულს გამოიმუშავებთ.',
		de: 'Anfragen von programmatischen Käufern nach Status. Je schneller Sie genehmigen und in den Status „Kampagne“ überführen, desto mehr Geld verdienen Sie.',
		ru: 'Заявки от покупателей программатик рекламы с делением по статусам. Чем быстрее они будут одобрены и переведены в статус “Кампания”, тем больше вы заработаете денег.',
		cn: /* TODO: to be translated */ 'Requests from programmatic buyers by status. The faster you will approve and transferred to the “Campaign" status, the more money you will earn.',
	},
	campaigns_ssp_hint: {
		en: 'Campaigns of programmatic buyers by status. Campaigns are Requests that were previously approved by your SSP account.',
		ge: 'პროგრამული მყიდველების კამპანიები სტატუსის მიხედვით. კამპანიები არის მოთხოვნები, რომლებიც ადრე იყო დამტკიცებული თქვენი SSP ანგარიშის მიერ.',
		de: 'Kampagnen programmatischer Käufer nach Status. Kampagnen sind Anfragen, die zuvor von Ihrem SSP-Konto genehmigt wurden.',
		ru: 'Кампании покупателей программатик рекламы с делением по статусам. Кампании - это Заявки ранее одобренные вашим аккаунтом SSP.',
		cn: /* TODO: to be translated */ 'Campaigns of programmatic buyers by status. Campaigns are Requests that were previously approved by your SSP account.',
	},
	balance_dsp_hint: {
		en: 'The balance of your DSP account, which is spent on the purchase of advertising.',
		ge: 'თქვენი DSP ანგარიშის ბალანსი, რომელიც იხარჯება რეკლამის შესაძენად.',
		de: 'Der Saldo Ihres DSP-Kontos, der für den Kauf von Werbung verwendet wird.',
		ru: 'Баланс вашего DSP аккаунта доступный для покупки рекламы.',
		cn: /* TODO: to be translated */ 'The balance of your DSP account, which is spent on the purchase of advertising.',
	},
	requests_dsp_hint: {
		en: 'Your requests for placement of Ad Campaigns.',
		ge: 'თქვენი მოთხოვნები სარეკლამო კამპანიების განთავსების შესახებ.',
		de: 'Ihre Anfragen zur Platzierung von Werbekampagnen.',
		ru: 'Ваши заявки на размещение Кампаний рекламы с делением по статусам.',
		cn: /* TODO: to be translated */ 'Your requests for placement of Ad Campaigns.',
	},
	campaigns_dsp_hint: {
		en: 'Your Campaigns are divided by status. Campaigns are Requests previously approved by the SSP administrator.',
		ge: 'თქვენი კამპანიები იყოფა სტატუსის მიხედვით. კამპანიები არის SSP ადმინისტრატორის მიერ ადრე დამტკიცებული მოთხოვნები.',
		de: 'Ihre Kampagnen sind nach Status unterteilt. Kampagnen sind Anfragen, die zuvor vom SSP-Administrator genehmigt wurden.',
		ru: 'Ваши Кампании с делением по статусам. Кампании - это Заявки ранее одобренные администратором сети.',
		cn: /* TODO: to be translated */ 'Your Campaigns are divided by status. Campaigns are Requests previously approved by the SSP administrator.',
	},
	empty_balance: {
		en: 'Contact admin to add money to your balance.',
		ge: 'დაუკავშირდით ადმინისტრატორს ბალანსზე ფულის დასამატებლად.',
		de: 'Kontaktieren Sie den Administrator, um Geld auf Ihr Guthaben zu laden.',
		ru: 'Свяжитесь с администратором, чтобы пополнить баланс',
		cn: /* TODO: to be translated */ 'Contact admin to add money to your balance.',
	},
	empty_balance_hint: {
		en: 'To start Campaigns, you need to have money on your balance. To top up your account, you need to contact the administrator who has given you access to the platform.',
		ge: 'კამპანიების დასაწყებად, ბალანსზე უნდა გქონდეთ ფული. თქვენი ანგარიშის შესავსებად, თქვენ უნდა დაუკავშირდეთ ადმინისტრატორს, რომელმაც მოგცათ პლატფორმაზე წვდომა.',
		de: 'Um Kampagnen zu starten, müssen Sie Geld auf Ihrem Konto haben. Um Ihr Konto aufzuladen, müssen Sie den Administrator kontaktieren, der Ihnen Zugang zur Plattform gewährt hat.',
		ru: 'Для старта Кампаний необходимо иметь средства на счету. Для пополнения баланса необходимо связаться с администратором, который предоставил вам доступ в платформу.',
		cn: /* TODO: to be translated */ 'To start Campaigns, you need to have money on your balance. To top up your account, you need to contact the administrator who has given you access to the platform.',
	},
	for_day: {
		en: 'For a day',
		ge: 'ერთი დღით',
		de: 'Für einen Tag',
		ru: 'За сутки',
		cn: /* TODO: to be translated */ 'For a day',
	},
	for_week: {
		en: 'For a week',
		ge: 'ერთი კვირის განმავლობაში',
		de: 'Für eine Woche',
		ru: 'За неделю',
		cn: /* TODO: to be translated */ 'For a week',
	},
	save: {
		en: 'Save',
		ge: 'შენახვა',
		de: 'Speichern',
		ru: 'Сохранить',
		cn: /* TODO: to be translated */ 'Save',
	},
	week_changes: {
		en: 'Compared to the previous week, this indicator changed by ',
		ge: 'წინა კვირასთან შედარებით, ეს მაჩვენებელი შეიცვალა',
		de: 'Im Vergleich zur Vorwoche hat sich dieser Indikator um ',
		ru: 'По сравнению с предыдущей неделей этот показатель изменился на ',
		cn: /* TODO: to be translated */ 'Compared to the previous week, this indicator changed by ',
	},
	day_changes: {
		en: 'Compared to the previous day, this indicator has changed by ',
		ge: 'წინა დღესთან შედარებით, ეს მაჩვენებელი შეიცვალა  ',
		de: 'Im Vergleich zum Vortag hat sich dieser Indikator um ',
		ru: 'По сравнению с прошлыми сутками этот показатель изменился на ',
		cn: /* TODO: to be translated */ 'Compared to the previous day, this indicator has changed by ',
	},
	download_inventory_list: {
		en: 'Inventory list',
		ge: 'ინვენტარის სია',
		de: 'Inventarliste',
		ru: 'Адресный план',
		cn: /* TODO: to be translated */ 'Inventory list',
	},
	by_who: {
		en: 'By',
		ge: 'გვერდზე',
		de: 'Von',
		ru: 'От',
		cn: /* TODO: to be translated */ 'By',
	},
	label: {
		en: 'Label',
		ge: 'ეტიკეტი',
		de: 'Label',
		ru: 'Лейбл',
		cn: /* TODO: to be translated */ 'Label',
	},
	good_uptime: {
		en: '<12h uptime',
		ge: '<12ს განამვლობაში',
		de: '<12h Betriebszeit',
		ru: '<12Ч время',
		cn: /* TODO: to be translated */ '<12h uptime',
	},
	average_uptime: {
		en: '>12h uptime',
		ge: '>12ს განამვლობაში',
		de: '>12h Betriebszeit',
		ru: '>12Ч время',
		cn: /* TODO: to be translated */ '>12h uptime',
	},
	bad_uptime: {
		en: '>48h',
		ge: '>48ს',
		de: '>48h',
		ru: '>48Ч',
		cn: /* TODO: to be translated */ '>48h',
	},
	uptime_hint: {
		en: 'The Uptime of devices is the time during which a request was made from a specific device to the server for the selection of ads for playback.\n' +
			'\n' +
			'Less than 12 hours is a great place to place ads with a large advertising capacity.\n' +
			'\n' +
			'More than 12 hours are places with a small free capacity for advertising at a given time or places with a poor Internet connection.\n' +
			'\n' +
			'More than 48 hours are places with the minimum free capacity for advertising at this time, possibly temporarily turned off devices or places with a poor Internet connection.',
		ge: 'მოწყობილობების მოქმედების დრო არის დრო, რომლის დროსაც მოხდა მოთხოვნა კონკრეტული მოწყობილობიდან სერვერზე რეკლამის ასარჩევად, დასაკრავად.\n' + 
			'\n' +
			'Less than 12 hours is a great place to place ads with a large advertising capacity.\n' +
			'\n' +
			'More than 12 hours are places with a small free capacity for advertising at a given time or places with a poor Internet connection.\n' +
			'\n' +
			'More than 48 hours are places with the minimum free capacity for advertising at this time, possibly temporarily turned off devices or places with a poor Internet connection.', /* TODO: to be translated */
		de: 'Die Betriebszeit von Geräten ist die Zeit, in der eine Anfrage von einem bestimmten Gerät an den Server zur Auswahl von Anzeigen für die Wiedergabe gestellt wurde.\n' +
			'\n' +
			'Weniger als 12 Stunden ist ein großartiger Ort, um Anzeigen mit einer großen Werbekapazität zu platzieren.\n' +
			'\n' +
			'Mehr als 12 Stunden sind Orte mit einem geringen freien Werbevolumen zu diesem Zeitpunkt oder Orte mit einer schlechten Internetverbindung.\n' +
			'\n' +
			'Mehr als 48 Stunden sind Orte mit der minimalen freien Kapazität für Werbung zu diesem Zeitpunkt, möglicherweise vorübergehend ausgeschaltete Geräte oder Orte mit einer schlechten Internetverbindung.',
		ru: 'Время безотказной работы устройств (Uptime) \n' +
			'- это время за которое от конкретного устройства был совершен запрос к серверу на подбор рекламы для воспроизведения.\n' +
			'\n' +
			'Менее 12 часов - это отличное место для размещения рекламы c большой ёмкостью для рекламы.\n' +
			'\n' +
			'Более 12 часов - это места с небольшой свободной ёмкостью для рекламы в данное время или места с плохим интернет соединением.\n' +
			'\n' +
			'Более 48 часов - это места с минимальной свободной ёмкостью для рекламы в данное время, возможно временно выключенные устройства или места с плохим интернет соединением.',
		cn: /* TODO: to be translated */ 'The Uptime of devices is the time during which a request was made from a specific device to the server for the selection of ads for playback.\n' +
			'\n' +
			'Less than 12 hours is a great place to place ads with a large advertising capacity.\n' +
			'\n' +
			'More than 12 hours are places with a small free capacity for advertising at a given time or places with a poor Internet connection.\n' +
			'\n' +
			'More than 48 hours are places with the minimum free capacity for advertising at this time, possibly temporarily turned off devices or places with a poor Internet connection.',
	},
	start_time: {
		en: 'start time',
		ge: 'დაწყების დრო',
		de: 'Startzeitpunkt',
		ru: 'время старта',
		cn: /* TODO: to be translated */ 'start time',
	},
	end_time: {
		en: 'end time',
		ge: 'დასრულების დრ',
		de: 'Endzeitpunkt',
		ru: 'время окончания',
		cn: /* TODO: to be translated */ 'end time',
	},
	approve_creatives_first_warning: {
		en: 'Please, approve creatives',
		ge: 'გთხოვთ, დაადასტურეთ შექმნა',
		de: 'Bitte genehmigen Sie die Werbemittel',
		ru: 'Пожалуйста, утвердите креативы',
		cn: /* TODO: to be translated */ 'Please, approve creatives',
	},
	advanced_settings_label: {
		en: 'Advanced Settings',
		ge: 'მოწინავე პარამეტრები',
		de: 'Erweiterte Einstellungen',
		ru: 'Расширенные настройки',
		cn: /* TODO: to be translated */ 'Advanced Settings',
	},
	date: {
		en: 'Date',
		ge: 'თარიღი',
		de: 'Datum',
		ru: 'Дата',
		cn: /* TODO: to be translated */ 'Date',
	},
	login: {
		en: 'Login',
		ge: 'შესვლა',
		de: 'Anmelden',
		ru: 'Логин',
		cn: '登录'
	},
	old_value: {
		en: 'Old value',
		ge: 'Old value',
		de: 'Old value',
		ru: 'Cтарое значение',
		cn: 'Old value'
	},
	new_value: {
		en: 'New value',
		ge: 'New value',
		de: 'New value',
		ru: 'Новое значение',
		cn: 'New value'
	},
	history_error: {
		en: 'Error getting history',
		ge: 'Error getting history',
		de: 'Error getting history',
		ru: 'Ошибка при получении истории',
		cn: 'Error getting history'
	},
	history_not_found: {
		en: 'No change history',
		ge: 'No change history',
		de: 'No change history',
		ru: 'История изменений отсутствует',
		cn: 'No change history'
	},
	changes_in_creative: {
		en: 'Changes in creative',
		ge: 'Changes in creative',
		de: 'Changes in creative',
		ru: 'Изменения в креативе',
		cn: 'Changes in creative'
	},
	old_device_list_count: {
		en: 'There were devices',
		ge: 'There were devices',
		de: 'There were devices',
		ru: 'Было устройств',
		cn: 'There were devices'
	},
	new_device_list_count: {
		en: 'Became devices',
		ge: 'Became devices',
		de: 'Became devices',
		ru: 'Стало устройств',
		cn: 'Became devices'
	},
	status: {
		en: 'status',
		ge: 'status',
		de: 'status',
		ru: 'cтатус',
		cn: 'status',
	},
	last_message: {
		en: 'last message',
		ge: 'last message',
		de: 'last message',
		ru: 'последнее сообщение',
		cn: 'last message',
	},
	action_add: {
		en: 'added',
		ge: 'added',
		de: 'added',
		ru: 'добавлен',
		cn: 'added',
	},
	action_remove: {
		en: 'removed',
		ge: 'removed',
		de: 'removed',
		ru: 'удален',
		cn: 'removed',
	},
	multi_spp_info_message: {
		en: 'To select several advertising platforms, you need to make different request',
		ge: 'To select several advertising platforms, you need to make different request',
		de: 'To select several advertising platforms, you need to make different request',
		ru: 'Для выбора нескольких площадок размещения рекламы требуется сделать разные заявки',
		cn: 'To select several advertising platforms, you need to make different request',
	}
};
